import TopBarComponent from "../components/TopBar"

const TopBar = () => {
  return (
    <TopBarComponent />
  )
}

export default TopBar